import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=695cd7dc&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=695cd7dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695cd7dc",
  null
  
)

export default component.exports